import { FC } from 'react'

import { NodeViewProps } from '@tiptap/react'
import clsx from 'clsx'

import { AppsEnum } from '../../../../constants/app.constants'
import { Container } from '../Container'

export const Image: FC<NodeViewProps> = props => {
  const { src, alt, app } = props.node.attrs

  const isGiphy = app === AppsEnum.Giphy

  return (
    <Container {...props} className="inline-block">
      <img
        className={clsx(
          'h-32 object-contain m-0',
          isGiphy && 'max-h-48',
          // size === 'full' && 'w-full'
        )}
        src={src}
        alt={alt}
      />
    </Container>
  )
}
